import React from 'react'

export const ArrowLeftIcon = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg'
    style={props.style}
    className='icon--arrowLeft'
    viewBox='0 0 32 32'
  >
    <path
      d='M8.8,16c0-0.4,0.2-0.8,0.4-1.1L20.4,3.8c0.6-0.6,1.5-0.6,2.1,0s0.6,1.5,0,2.1L12.4,16l10.1,10.1c0.6,0.6,0.6,1.5,0,2.1s-1.5,0.6-2.1,0L9.3,17.1C9,16.8,8.8,16.4,8.8,16z'
    />
  </svg>
)
